export const requisites = {
    ogrn: '1247700541692',
    inn: '9715490350',
    kpp: '771501001',
    okpo: '89108492',
    oktao: '45280574000',
    okfs: '16, Частная собственность',
    oktmo: '45359000000',
    okogu: '4210014',
    okopf: '12300',
    registration_data: '12.08.2024',
    ur_address: '127566, город Москва, Алтуфьевское ш, д. 44, помещ. 19',
    director: 'Заболотный Михаил Евгеньевич',
}

export const contacts = {
    first_phone: '79014175368',
    info_mail: 'info@moda-ceramics.store',
    whatsapp: 'https://api.whatsapp.com/send/?phone=79265719912&text&type=phone_number&app_absent=0',
    telegram: 'https://t.me/ModaCeramics',
    yandex_map_link: 'https://yandex.ru/maps/org/moda_keramiks/92601266407/?ll=37.589480%2C55.874500&z=18.66',
    address: 'Москва, ш Алтуфьевское, дом 44, помещение 19',
}
